import { Route } from "react-router-dom";
import React from "react";
import PropTypes from "prop-types";
import { getContentWrapperClass } from "../../utils/header";

const PrivateRoute = ({ component, path, authenticated }) => {
  return (
    <Route
      path={path}
      render={() =>
        authenticated === true ? (
          React.createElement(component, { ...this.props })
        ) : (
          <div className={getContentWrapperClass(this.props)}>
            <div className="voucherHistorySection">
              <div className="row">
                <div className="col-md-12">
                  <div className="headingSection">
                    <h4 className="text-left">Access Denied!</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    />
  );
};

const { object, bool, string, func } = PropTypes;

PrivateRoute.propTypes = {
  component: func.isRequired,
  exact: bool,
  path: string.isRequired,
  authenticated: bool.isRequired,
  location: object,
};
export default PrivateRoute;
